<template>
    <el-card shadow="never">
      <template #header>
        <div class="header">
          <el-breadcrumb class="breadcrumb" separator="/">
            <el-breadcrumb-item :to="{ path: '/company' }">公司列表</el-breadcrumb-item>
            <el-breadcrumb-item>编辑公司</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
      <div style="width:80%">
        <el-form :model="form" label-width="120px">
            <el-form-item label="公司名称">
                <el-input v-model="form.title" maxlength="150" show-word-limit/>
            </el-form-item>
            <el-form-item label="公司简称">
                <el-input v-model="form.subtitle" maxlength="150" show-word-limit/>
            </el-form-item>
            <el-form-item label="管理者">
              <el-select v-model="form.memberid" placeholder="Select">
                <el-option v-for="item in baseData.memberlist" :key="item.id" :label="item.nickname" :value="item.id">{{item.nickname}}</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="分类名称">
                <el-cascader
                    v-model="form.cates"
                    :options="baseData.cateslist"
                    :props="propss"
                    clearable
                    @change="handleChange"
                />
            </el-form-item>
            <el-form :model="form" :inline="true" label-width="120px">
                <el-form-item label="Logo">
                    <el-row class="martop">
                        <el-upload
                        class="avatar-uploader"
                        action=""
                        :http-request="uploadLogo"
                        :show-file-list="false"
                        >
                        <img v-if="form.img" :src="form.img" class="avatar" />
                        <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
                        <template #tip>
                            <div class="el-upload__tip">
                            请上传jpg/png的统一尺寸图片，图片比例为1:1，<br>
                            推荐尺寸：200px*200px,图片大小不能大于2M
                            </div>
                        </template>
                        </el-upload>
                    </el-row>
                </el-form-item>
                <el-form-item label="联系二维码图">
                    <el-row class="martop">
                        <el-upload
                        class="avatar-uploader"
                        action=""
                        :http-request="uploadcontactimg"
                        :show-file-list="false"
                        >
                        <img v-if="form.contactImg" :src="form.contactImg" class="avatar" />
                        <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
                        <template #tip>
                            <div class="el-upload__tip">
                                <div>请上传jpg/png的统一尺寸图片，图片比例为1:1，</div>
                                <div style="display: flex;">推荐尺寸：200px*200px,图片大小不能大于2M,<el-button type="danger" @click="showtipsbox()" link>查看示例</el-button></div>
                            </div>
                        </template>
                        </el-upload>
                    </el-row>
                </el-form-item>
            </el-form>
            <el-form-item label="banner轮播图">
                <el-upload
                    v-model:file-list="form.imglist"
                    action=""
                    :http-request="uploadImg"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                >
                    <el-icon><Plus /></el-icon>
                    <template #tip>
                        <div class="el-upload__tip">
                          请上传jpg/png的统一尺寸图片，图片比例为3:4，推荐尺寸：390px*520px,图片大小不能大于6M
                        </div>
                      </template>
                </el-upload>
    
                <el-dialog v-model="dialogVisible">
                    <img w-full :src="dialogImageUrl" alt="Preview Image" />
                </el-dialog>
            </el-form-item>
            <el-form :model="form" :inline="true" label-width="120px">
              <el-form-item label="更多设置">
                <el-checkbox v-model="form.isRecommend" label="推荐" />
              </el-form-item>
              <el-form-item label=" ">
                <el-checkbox v-model="form.isTop" label="顶置" />
              </el-form-item>
            </el-form>
            <el-form :model="form" :inline="true" label-width="120px">
                <el-form-item label="公司联系人">
                    <el-input v-model="form.name" maxlength="150" show-word-limit/>
                </el-form-item>
                <el-form-item label="微信号">
                    <el-input v-model="form.wxcode" maxlength="150" show-word-limit/>
                </el-form-item>
                <el-form-item label="网址">
                  <el-input v-model="form.website" maxlength="250" show-word-limit/>
                </el-form-item>
                <el-form-item label="职位">
                    <el-input v-model="form.position" maxlength="150" show-word-limit/>
                </el-form-item>
                <el-form-item label="公司电话">
                    <el-input v-model="form.phone" maxlength="150" show-word-limit/>
                </el-form-item>
                <el-form-item label="邮箱">
                    <el-input v-model="form.email" maxlength="150" show-word-limit/>
                </el-form-item>
                <el-form-item label="地址" style="width: 100%">
                    <el-input v-model="form.address" maxlength="250" show-word-limit/>
                </el-form-item>
                <el-form-item label="简介" style="width: 100%">
                    <el-input type="textarea" v-model="form.introduction" maxlength="250" show-word-limit/>
                </el-form-item>
            </el-form>
            <el-form-item label="关于我们-轮播图">
                <el-upload
                    v-model:file-list="form.aboutimglist"
                    action=""
                    :http-request="uploadAboutImg"
                    list-type="picture-card"
                    :on-preview="handleAboutPictureCardPreview"
                    :on-remove="handleAboutRemove"
                >
                    <el-icon><Plus /></el-icon>
                    <template #tip>
                        <div class="el-upload__tip">
                          请上传jpg/png的统一尺寸图片，图片比例为7:4，推荐尺寸：350px*200px,图片大小不能大于6M
                        </div>
                      </template>
                </el-upload>
    
                <el-dialog v-model="dialogAboutVisible">
                    <img w-full :src="dialogAboutImageUrl" alt="Preview Image" />
                </el-dialog>
            </el-form-item>
            <el-form-item label="公司详情图">
                <el-upload
                    v-model:file-list="form.detailimglist"
                    action=""
                    :http-request="uploadDetailImg"
                    list-type="picture-card"
                    :on-preview="handleDetailPictureCardPreview"
                    :on-remove="handleDetailRemove"
                >
                    <el-icon><Plus /></el-icon>
                    <template #tip>
                        <div class="el-upload__tip">
                          请上传jpg/png的统一尺寸图片，图片比例为1:2，推荐尺寸：350px*700px,图片大小不能大于10M
                        </div>
                      </template>
                </el-upload>
    
                <el-dialog v-model="dialogDetailVisible">
                    <img w-full :src="dialogDetailImageUrl" alt="Preview Image" />
                </el-dialog>
            </el-form-item>
            <!-- <el-form-item label="到期时间">
              <el-date-picker
                v-model="form.end_time"
                type="datetime"
                placeholder=""
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
              />
            </el-form-item> -->
            <el-form-item label="状态">
              <el-radio-group v-model="form.status">
                <el-radio label="0">冻结</el-radio>
                <el-radio label="1">待审核</el-radio>
                <el-radio label="2">正常</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">保存</el-button>
                <el-button @click="goBack">返回</el-button>
            </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-dialog v-model="baseData.tipsbox" title="提示">
        <div>
          实力
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="baseData.tipsbox = false">取消</el-button>
            <el-button type="primary" @click="baseData.tipsbox = false">确认</el-button>
          </span>
        </template>
      </el-dialog>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted, ref } from 'vue'
  import api from '@/api/index'
  import { ElMessage, ElLoading, UploadProps, UploadUserFile } from 'element-plus'
  import {useRouter, useRoute} from 'vue-router'
import { isTemplate } from 'element-plus/es/utils'

  const router = useRouter()
  const route = useRoute()
  const baseData = reactive({
    loading: false,
    tipsbox: false,
    cateslist: [],
    memberlist: [],
  })
  const propss = {
    expandTrigger: 'hover' as const,
    value:'id',
    label:'title',
    children:'children',
  }
  const form:any = reactive({
    id: '',
    memberid:'',
    cid:'',
    cates: [],
    imglist: [],
    aboutimglist: [],
    detailimglist: [],
    title:'',
    subtitle:'',
    img:'',
    contactImg:'',
    name: '',
    position: '',
    phone: '',
    email: '',
    address: '',
    wxcode: '',
    website: '',
    isRecommend: '',
    isTop: '',
    introduction: '',
    end_time: '',
    status: 1,
  })
  const dialogImageUrl = ref('')
  const dialogVisible = ref(false)
  const dialogAboutImageUrl = ref('')
  const dialogAboutVisible = ref(false)
  const dialogDetailImageUrl = ref('')
  const dialogDetailVisible = ref(false)

  const showtipsbox = () => {
    baseData.tipsbox = true
  }
  const getCatesList = () => {
    baseData.loading = true
    api.companyApi.get_cates_list({limit:1000,page:1}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        baseData.cateslist = res.data.list
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const getCompanyMemberList = () => {
    api.memberApi.getCompanyMemberList({limit:3000,page:1,cid:route.params.id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        baseData.memberlist = res.data.list
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const handleChange = (value:any) => {
    form.cid = value[value.length - 1]
  }
  const get = () => {
    const loading = ElLoading.service({lock: true})
    api.companyApi.get({id:route.params.id}).then((res:any)=>{
      if(res.code==200){
        form.memberid = res.data.companyinfo.memberid
        form.cid = res.data.companyinfo.cid
        form.cate = res.data.companyinfo.cate
        form.cates = res.data.companyinfo.cates
        for(let i=0;i<form.cates.length;i++){
          form.cates[i] = parseInt(form.cates[i])
        }
        form.img = res.data.companyinfo.img
        form.contactImg = res.data.companyinfo.contactImg
        form.imglist = res.data.imglist ? res.data.imglist : []
        form.aboutimglist = res.data.aboutimglist ? res.data.aboutimglist : []
        form.detailimglist = res.data.detailimglist ? res.data.detailimglist : []
        form.title = res.data.companyinfo.title
        form.subtitle = res.data.companyinfo.subtitle
        form.name = res.data.companyinfo.name
        form.position = res.data.companyinfo.position
        form.phone = res.data.companyinfo.phone
        form.email = res.data.companyinfo.email
        form.address = res.data.companyinfo.address
        form.wxcode = res.data.companyinfo.wxcode
        form.website = res.data.companyinfo.website
        form.introduction = res.data.companyinfo.introduction
        form.isRecommend= res.data.companyinfo.isRecommend == 1 ? true : false
        form.isTop= res.data.companyinfo.isTop == 1 ? true : false
        form.end_time= res.data.companyinfo.end_time
        form.status = String(res.data.companyinfo.status)
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const onSubmit = () => {
    let data = {...form};
    data.isTop = data.isTop == true ? 1 : 0
    data.isRecommend = data.isRecommend == true ? 1 : 0
    data.cates = data.cates.length > 0 ? data.cates.join(',') : ''
    data.imglist = data.imglist.length ? JSON.stringify(data.imglist) : ""
    data.aboutimglist = data.aboutimglist.length ? JSON.stringify(data.aboutimglist) : ""
    data.detailimglist = data.detailimglist.length ? JSON.stringify(data.detailimglist) : ""
    const loading = ElLoading.service({lock: true})
    api.companyApi.edit(data).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        router.push("/company");
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const goBack = () => {
    router.go(-1);
  }
  const uploadLogo = (params:any) => {
    const loading = ElLoading.service({lock: true})
    const file = params.file,formData1 = new FormData();
    if (file.size / 1024 / 1024 > 2) {
        ElMessage.error('Logo图超过2MB!')
        return false
    }
    formData1.append("file", file)
    api.commonApi.uploadImg(formData1).then((res:any)=>{
      loading.close()
        if(res.code == 200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          form.img = res.data.img
        }else{
          ElMessage.error(res.message)
        }
    })
  }
  const uploadcontactimg = (params:any) => {
    const loading = ElLoading.service({lock: true})
    const file = params.file,formData1 = new FormData();
    if (file.size / 1024 / 1024 > 2) {
        ElMessage.error('联系二维码图超过2MB!')
        return false
    }
    formData1.append("file", file)
    api.commonApi.uploadImg(formData1).then((res:any)=>{
      loading.close()
        if(res.code == 200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          form.contactImg = res.data.img
        }else{
          ElMessage.error(res.message)
        }
    })
  }
  const uploadImg = (params:any) => {
    const file = params.file,formData = new FormData();
    if (file.size / 1024 / 1024 > 6) {
        ElMessage.error('banner轮播图超过6MB!')
        return false
    }
    formData.append("file", file)
    api.commonApi.uploadImg(formData).then((res:any)=>{
        if(res.code == 200){
        let data = {name:file.name,url:res.data.img}
        form.imglist.pop()
        form.imglist.push(data);
        }
    })
  }
  const uploadAboutImg = (params:any) => {
    const file = params.file,formData = new FormData();
    if (file.size / 1024 / 1024 > 6) {
        ElMessage.error('banner轮播图超过6MB!')
        return false
    }
    formData.append("file", file)
    api.commonApi.uploadImg(formData).then((res:any)=>{
        if(res.code == 200){
        let data = {name:file.name,url:res.data.img}
        form.aboutimglist.pop()
        form.aboutimglist.push(data);
        }
    })
  }
  const uploadDetailImg = (params:any) => {
    const file = params.file,formData = new FormData();
    if (file.size / 1024 / 1024 > 6) {
        ElMessage.error('banner轮播图超过10MB!')
        return false
    }
    formData.append("file", file)
    api.commonApi.uploadImg(formData).then((res:any)=>{
        if(res.code == 200){
        let data = {name:file.name,url:res.data.img}
        form.detailimglist.pop()
        form.detailimglist.push(data);
        }
    })
  }
  const handleRemove: UploadProps['onRemove'] = (uploadFile, uploadFiles) => {
    console.log(uploadFile, uploadFiles)
  }

  const handlePictureCardPreview: UploadProps['onPreview'] = (uploadFile) => {
    dialogImageUrl.value = uploadFile.url!
    dialogVisible.value = true
  }

  const handleAboutRemove: UploadProps['onRemove'] = (uploadFile, uploadFiles) => {
    console.log(uploadFile, uploadFiles)
  }

  const handleAboutPictureCardPreview: UploadProps['onPreview'] = (uploadFile) => {
    dialogAboutImageUrl.value = uploadFile.url!
    dialogAboutVisible.value = true
  }
  const handleDetailRemove: UploadProps['onRemove'] = (uploadFile, uploadFiles) => {
    console.log(uploadFile, uploadFiles)
  }

  const handleDetailPictureCardPreview: UploadProps['onPreview'] = (uploadFile) => {
    dialogDetailImageUrl.value = uploadFile.url!
    dialogDetailVisible.value = true
  }
  onMounted(() => {
    form.id = route.params.id
    get()
    getCatesList()
    getCompanyMemberList()
  })
  </script>